import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fileList", "progress", "progressBar", "dropzone"]
  static values = {
    videoTooLong: String,
    videoLoadError: String
  }

  triggerFileInput() {
    this.inputTarget.click()
  }

  handleFileSelect() {
    const file = this.inputTarget.files[0] // 단일 파일만 처리

    if (file && file.type.startsWith('video/')) {
      this.validateVideoDuration(file)
    } else {
      this.showFileUI(file)
    }
  }

  removeFile() {
    this.inputTarget.value = null
    this.fileListTarget.innerHTML = ''
    this.progressTarget.classList.add("hidden")
    this.progressBarTarget.style.width = '0%'

    this.dispatch("fileRemoved")
  }

  boundHandleVisit(event) {
    if (event.detail.url !== window.location.href) {
      this.removeFile()
    }
  }

  // Active Storage의 직접 업로드 진행률 표시
  connect() {
    document.addEventListener("turbo:before-visit", this.boundHandleVisit.bind((this)))

    this.inputTarget.addEventListener("direct-upload:initialize", event => {
      console.log("UPLADER::::direct-upload:initialize")
      this.progressTarget.classList.remove("hidden")
    })

    this.inputTarget.addEventListener("direct-uploads:start", event => {
      console.log("UPLADER::::direct-uploads:start")
    })

    this.inputTarget.addEventListener("direct-upload:progress", event => {
      const { progress } = event.detail
      this.progressBarTarget.style.width = `${progress}%`
      console.log("UPLADER::::direct-upload:progress - ", Math.round(progress))
    })

    this.inputTarget.addEventListener("direct-upload:error", event => {
      console.log("UPLADER::::direct-upload:error")
      event.preventDefault()
      const { error } = event.detail
      alert(`업로드 중 오류가 발생했습니다: ${error}`)
    })
    this.inputTarget.addEventListener("direct-uploads:end", event => {
      console.log("UPLADER::::direct-upload:end")
    })
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.boundHandleVisit.bind((this)))
  }

  handleDragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('border-blue-500', 'bg-blue-50')
  }

  handleDragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-blue-500', 'bg-blue-50')
  }

  handleDrop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-blue-500', 'bg-blue-50')

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  validateVideoDuration(file) {
    const video = document.createElement('video')
    video.preload = 'metadata'

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src)
      const duration = video.duration

      if (duration > 7200) {
        this.removeFile()
        alert(this.videoTooLongValue)
        return
      }

      this.showFileUI(file)
    }

    video.onerror = () => {
      window.URL.revokeObjectURL(video.src)
      this.removeFile()
      alert(this.videoLoadErrorValue)
    }

    video.src = URL.createObjectURL(file)
  }

  showFileUI(file) {
    this.fileListTarget.innerHTML = `
      <div class="flex items-center justify-between p-2 bg-white border border-gray-200 rounded-md">
        <span class="text-sm text-gray-700">${file.name}</span>
        <button
          type="button"
          class="text-red-500 hover:text-red-700 transition-colors duration-200"
          data-action="click->upload#removeFile"
        >
          &times;
        </button>
      </div>
    `

    this.progressTarget.classList.remove("hidden")
  }
}
